import React from 'react';

import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

import type { ForgeAppsProps } from './ForgeAppTabs.tsx';
// eslint-disable-next-line import/no-cycle
import { SpaceSettingsNavigationV1 } from './SpaceSettingsNavigationV1.tsx';
import { SpaceSettingsNavigationV2 } from './SpaceSettingsNavigationV2.tsx';

// Duplicates the type and constant from SpaceSettingsNavigationV1 in order to avoid test failures.
export type SpaceSettingsNavigationProps = ForgeAppsProps & {
	children?: (props: { withCompleteNav: boolean }) => React.ReactNode | React.ReactNode;
	onLoadForgeApps?: Function;
	onLoadForgeError?: (Error: any) => void;
};
export const ANALYTICS_SOURCE = 'spaceSettingsV2InnerTabs';

/**
 * Renders Confluence Space Settings V2 tab navigation, including Connect and Forge apps.
 * This navigation may be used both on legacy monolith SSR space settings pages (where
 * it is injected via React portal), and on fully React SPA space settings pages (currently
 * only the Forge app space settings page).
 * This component handles only rendering the navigation tabs, not page contents.
 */
export const SpaceSettingsNavigation = (props: SpaceSettingsNavigationProps): React.JSX.Element => {
	if (!isCompanyHubSpaceKey(props.spaceKey)) {
		return <SpaceSettingsNavigationV2 {...props} />;
	} else {
		return <SpaceSettingsNavigationV1 {...props} />;
	}
};
